import formEmbeddableMixin from "@/mixins/embeddable/resource/formEmbeddableMixin";
import ProductFormProductionEmbeddable from "@/views/modules/product/embeddable/ProductFormProductionEmbeddable";
import ProductFormArchEmbeddable from "@/views/modules/product/embeddable/ProductFormArchEmbeddable";
import ProductEntity from "@/model/entities/modules/product/ProductEntity";


export default {
    components: {ProductFormProductionEmbeddable,ProductFormArchEmbeddable},
    mixins: [formEmbeddableMixin],
    data() {
        return {
            path: "product",
            form: new ProductEntity()
        }

    },
    /*created(){
        this.form =
    },*/
    methods: {


    }
}